import React, { useState, useEffect } from "react";

import { motion } from "framer-motion";
import Header from "./components/Header";
import FileUpload from "./components/FileUpload";
import TranscriptPanel from "./components/TranscriptPanel";
import ChatPanel from "./components/ChatPanel";
import LoadingSpinner from "./components/LoadingSpinner";
import api from "./services/api";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
import PinLockScreen from "./components/PinLockScreen";
import MeetingHistoryList from "./components/MeetingHistoryList";
import MobileHistoryModal from "./components/MobileHistoryModal";
import {
  FiList,
  FiArchive,
  FiChevronRight,
  FiInfo,
  FiDownload as FiImport,
} from "react-icons/fi";
import { addDays } from "date-fns";
import LoginScreen from "./components/LoginScreen";
import "./App.css";

const inspirationalQuotes = [
  {
    quote: "วิธีเดียวที่จะสร้างผลงานที่ยอดเยี่ยมได้ คือการรักในสิ่งที่คุณทำ",
    author: "สตีฟ จ็อบส์",
  },
  { quote: "จินตนาการสำคัญกว่าความรู้", author: "อัลเบิร์ต ไอน์สไตน์" },
  {
    quote: "วิธีเริ่มต้นที่ดีที่สุด คือการหยุดพูดแล้วลงมือทำ",
    author: "วอลต์ ดิสนีย์",
  },
  {
    quote: "มันดูเหมือนเป็นไปไม่ได้เสมอ จนกระทั่งมันสำเร็จ",
    author: "เนลสัน แมนเดลา",
  },
  {
    quote:
      "ผมล้มเหลวครั้งแล้วครั้งเล่าในชีวิต และนั่นคือเหตุผลที่ผมประสบความสำเร็จ",
    author: "ไมเคิล จอร์แดน",
  },
  {
    quote: "อนาคตเป็นของผู้ที่เชื่อในความฝันของตนเอง",
    author: "เอเลนอร์ โรสเวลต์",
  },
  {
    quote:
      "ความสำเร็จไม่ใช่จุดสิ้นสุด ความล้มเหลวไม่ใช่หายนะ แต่คือความกล้าที่จะเดินต่อ",
    author: "วินสตัน เชอร์ชิลล์",
  },
  { quote: "ถ้าคุณฝันถึงมันได้ คุณก็ทำมันได้", author: "วอลต์ ดิสนีย์" },
  {
    quote:
      "อีกยี่สิบปีข้างหน้า คุณจะผิดหวังกับสิ่งที่ไม่ได้ทำ มากกว่าสิ่งที่ได้ทำลงไป",
    author: "มาร์ก ทเวน",
  },
  {
    quote: "อุปสรรคคือสิ่งที่น่ากลัว ที่คุณเห็นเมื่อละสายตาจากเป้าหมาย",
    author: "เฮนรี่ ฟอร์ด",
  },
  {
    quote: "คนที่พูดว่าทำไม่ได้ ควรหลีกทางให้คนที่กำลังลงมือทำ",
    author: "สุภาษิตจีน",
  },
  {
    quote: "จงเป็นการเปลี่ยนแปลงที่คุณอยากเห็นในโลกนี้",
    author: "มหาตมะ คานธี",
  },
  { quote: "การเดินทางนับพันลี้ ต้องเริ่มต้นจากก้าวแรก", author: "เล่าจื๊อ" },
  {
    quote: "อัจฉริยะคือแรงบันดาลใจ 1% และอีก 99% คือหยาดเหงื่อแรงกาย",
    author: "โธมัส เอดิสัน",
  },
  {
    quote: "จงตั้งเป้าไปที่ดวงจันทร์ แม้พลาดก็ยังอยู่ท่ามกลางดวงดาว",
    author: "นอร์แมน วินเซนต์ พีล",
  },
  { quote: "ความลับของการก้าวไปข้างหน้า คือการเริ่มต้น", author: "มาร์ก ทเวน" },
  {
    quote: "เชื่อว่าคุณทำได้ แล้วคุณก็ไปได้ครึ่งทางแล้ว",
    author: "ธีโอดอร์ โรสเวลต์",
  },
  { quote: "คุณภาพไม่ใช่การกระทำ แต่เป็นนิสัย", author: "อริสโตเติล" },
  { quote: "นวัตกรรมคือสิ่งที่แบ่งแยกผู้นำกับผู้ตาม", author: "สตีฟ จ็อบส์" },
  {
    quote: "ไม่ว่าคุณจะคิดว่าคุณทำได้หรือทำไม่ได้ คุณก็คิดถูก",
    author: "เฮนรี่ ฟอร์ด",
  },
  { quote: "การเรียนรู้ไม่เคยทำให้สมองอ่อนล้า", author: "เลโอนาร์โด ดา วินชี" },
  {
    quote: "โอกาสไม่ได้เกิดขึ้นเอง แต่คุณต้องสร้างมันขึ้นมา",
    author: "คริส กรอสเซอร์",
  },
  {
    quote:
      "ความสำเร็จคือผลรวมของความพยายามเล็กๆ ที่เกิดขึ้นซ้ำแล้วซ้ำเล่าในทุกๆ วัน",
    author: "โรเบิร์ต คอลลิเออร์",
  },
  {
    quote: "ผู้ชนะไม่เคยล้มเลิก และผู้ที่ล้มเลิกก็ไม่เคยชนะ",
    author: "วินซ์ ลอมบาร์ดี",
  },
  {
    quote:
      "เวลาที่ดีที่สุดในการปลูกต้นไม้คือเมื่อ 20 ปีที่แล้ว เวลาที่ดีที่สุดรองลงมาคือตอนนี้",
    author: "สุภาษิตจีน",
  },
];

const UPLOAD_HISTORY_KEY = "uploadHistory_v1";
const SAVED_MEETINGS_KEY = "savedMeetings_v2";
const SPLIT_FILE_HISTORY_KEY = "splitfileHistory_v1";
const SAVED_ORIGINAL_RECORDER_KEY = "savedOriginalRecorder_v1";

const formatDuration = (seconds) => {
  if (isNaN(seconds) || seconds < 0) return "00:00";
  const date = new Date(seconds * 1000);
  const hh = date.getUTCHours();
  const mm = date.getUTCMinutes();
  const ss = date.getUTCSeconds().toString().padStart(2, "0");
  if (hh > 0) {
    return `${hh}:${mm.toString().padStart(2, "0")}:${ss}`;
  }
  return `${mm}:${ss}`;
};

const getMediaDuration = (file) => {
  return new Promise((resolve, reject) => {
    try {
      const url = URL.createObjectURL(file);
      const media = new Audio(url);
      const cleanup = () => {
        // Revoke the URL after a short delay to avoid race conditions
        setTimeout(() => URL.revokeObjectURL(url), 100);
      };
      media.onloadedmetadata = () => {
        resolve(media.duration);
        cleanup();
      };
      media.onerror = (err) => {
        reject("Error loading media file.");
        cleanup();
      };
    } catch (error) {
      reject("Error creating object URL.");
    }
  });
};

function App() {
  const [uploadHistory, setUploadHistory] = useState([]);
  const [savedMeetings, setSavedMeetings] = useState([]);
  const [activeMeeting, setActiveMeeting] = useState(null);

  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isChatLoading, setIsChatLoading] = useState(false);
  const [quoteData, setQuoteData] = useState(inspirationalQuotes[0]);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [pinError, setPinError] = useState("");
  const [isVerifyingPin, setIsVerifyingPin] = useState(false);
  const [layoutDirection, setLayoutDirection] = useState("horizontal");
  const [isMobileHistoryModalOpen, setIsMobileHistoryModalOpen] =
    useState(false);

  const [isVideoError, setIsVideoError] = useState(false);

  const [authError, setAuthError] = useState("");
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  useEffect(() => {
    const loadAllHistories = () => {
      try {
        const uploads = JSON.parse(
          localStorage.getItem(UPLOAD_HISTORY_KEY) || "[]"
        );
        uploads.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setUploadHistory(uploads);

        const saved = JSON.parse(
          localStorage.getItem(SAVED_MEETINGS_KEY) || "[]"
        );
        saved.sort(
          (a, b) =>
            new Date(b.lastModified || b.createdAt) -
            new Date(a.lastModified || a.createdAt)
        );
        setSavedMeetings(saved);
      } catch (error) {
        console.error("Error loading histories:", error);
      }
    };

    loadAllHistories();

    const pollStatuses = async () => {
      const currentUploads = JSON.parse(
        localStorage.getItem(UPLOAD_HISTORY_KEY) || "[]"
      );
      const meetingsToPoll = currentUploads.filter(
        (m) => m.status === "transcribing"
      );

      if (meetingsToPoll.length === 0) return;

      let hasChanges = false;
      for (const job of meetingsToPoll) {
        const result = await api.checkTranscriptionStatus(job.jobId, job.dbId);
        console.log("checkTranscriptionStatus ,", job.dbId, result);
        if (result.status === "finished" || result.status === "failed") {
          // API returns 'completed' now
          hasChanges = true;
          const jobIndex = currentUploads.findIndex((m) => m.id === job.id);
          if (jobIndex > -1) {
            currentUploads[jobIndex].status =
              result.status === "finished" ? "finished" : "failed";
            currentUploads[jobIndex].transcriptContent = result.transcript;
            currentUploads[jobIndex].error = result.error;
            if (result.status === "failed") {
              currentUploads[jobIndex].retryCount = result.retryCount;
            }
          }
        }
      }

      if (hasChanges) {
        localStorage.setItem(
          UPLOAD_HISTORY_KEY,
          JSON.stringify(currentUploads)
        );

        loadAllHistories();

        setUploadHistory(currentUploads);
      }
    };

    const intervalId = setInterval(pollStatuses, 5000);
    window.addEventListener("storage", loadAllHistories);
    return () => {
      clearInterval(intervalId);
      window.removeEventListener("storage", loadAllHistories);
    };
  }, []);

  useEffect(() => {
    let intervalId;
    if (isUploading) {
      intervalId = setInterval(() => {
        const randomIndex = Math.floor(
          Math.random() * inspirationalQuotes.length
        );
        setQuoteData(inspirationalQuotes[randomIndex]);
      }, 6000);
    }
    return () => clearInterval(intervalId);
  }, [isUploading]);

  useEffect(() => {
    const checkSize = () =>
      setLayoutDirection(window.innerWidth < 1024 ? "vertical" : "horizontal");
    checkSize();
    window.addEventListener("resize", checkSize);
    return () => window.removeEventListener("resize", checkSize);
  }, []);

  useEffect(() => {
    const sessionAuth = sessionStorage.getItem("isAuthenticated") === "true";
    if (sessionAuth) {
      setIsAuthenticated(true);
      try {
        const sessionUser = JSON.parse(sessionStorage.getItem("user"));
        if (sessionUser) {
          setUser(sessionUser);
        }
      } catch (error) {
        console.error("Failed to parse user from session storage", error);
      }
    }
  }, []);

  const handleLoginSubmit = async ({ email, password }) => {
    setIsLoggingIn(true);
    setAuthError("");

    const result = await api.login(email, password); // <-- เรียกใช้ฟังก์ชัน login ใหม่

    if (result.success) {
      setIsAuthenticated(true);
      setUser(result.user); // Assuming api.login returns the user object
      sessionStorage.setItem("isAuthenticated", "true");
      //sessionStorage.setItem("user", JSON.stringify(result.user));
    } else {
      setAuthError(result.error + (result.error2 ? `\n${result.error2}` : ""));
    }
    setIsLoggingIn(false);
  };
  const handleLogout = () => {
    api.logout(); // This will remove authToken from localStorage
    setIsAuthenticated(false);
    setUser(null);
    sessionStorage.removeItem("isAuthenticated");
    sessionStorage.removeItem("user");
    window.location.reload();
  };

  const handlePinSubmit = async (pin) => {
    setIsVerifyingPin(true);
    setPinError("");
    const result = await api.verifyPin(pin);
    if (result && result.success) {
      setIsAuthenticated(true);
      sessionStorage.setItem("isAuthenticated", "true");
    } else {
      setPinError("รหัส PIN ไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง");
    }
    setIsVerifyingPin(false);
  };

  const handleFileUploadLogic = (
    file,
    skipTranscription = false,
    duration = 0,
  ) => {
    // Use the same file size logic as FileUpload.jsx
    const regularUploadLimit = 200 * 1024 * 1024; // 200MB
    const largeFileLimit = 300 * 1024 * 1024; // 300MB
    const chunkedUploadThreshold = 50 * 1024 * 1024; // 50MB - threshold for using chunked upload
    const chunkedUploadDurationThreshold = 5 * 60; // 5 minutes - threshold for using chunked upload based on duration
    
    // Check if file exceeds maximum allowed size
    if (file.size > largeFileLimit) {
      alert(
        `ไฟล์มีขนาดใหญ่เกินไป (${(file.size / 1024 / 1024).toFixed(2)} MB). ขนาดสูงสุดที่อนุญาตคือ 300 MB.`
      );
      return;
    }
    
    // Check if file is too large for regular transcription (but not skipping transcription)
    if (file.size > regularUploadLimit && !skipTranscription) {
      alert(
        `File is too large (${(file.size / 1024 / 1024).toFixed(
          2,
        )} MB). Please use the 'Upload Large File' button.`,
      );
      return;
    }
    
    // Decide between regular and chunked upload based on file size, duration, or skipTranscription flag
    const shouldUseChunkedUpload = 
      file.size > chunkedUploadThreshold || 
      duration > chunkedUploadDurationThreshold || 
      skipTranscription;
    
    if (shouldUseChunkedUpload) {
      console.log(
        `Using chunked upload. File size: ${(file.size / 1024 / 1024).toFixed(2)}MB, Duration: ${Math.floor(duration / 60)}:${Math.floor(duration % 60).toString().padStart(2, '0')}, Skip transcription: ${skipTranscription}`
      );
      handleChunkedFileUpload(file, skipTranscription, duration);
    } else {
      console.log("File size and duration are within limits, using regular upload.");
      handleFileUpload(file, skipTranscription, duration);
    }
  };

  const handleChunkedFileUpload = async (
    file,
    skipTranscription = false,
    duration = 0,
  ) => {
    setIsUploading(true);
    setUploadProgress(0);
    
    // Add duration validation logic from FileUpload.jsx
    if (!skipTranscription) {
      try {
        const mediaDuration = duration || (await getMediaDuration(file));
        const maxDuration = 150 * 60; // 150 minutes (2.5 hours)
        if (mediaDuration > maxDuration) {
          const userConfirmed = window.confirm(
            "การประชุม เกิน 2.5 ชม คุยสามารถทำรายการต่อไปได้ แต่ว่า คำพูดที่ถอดอาจไม่ครบถ้วน (แต่คุณยังใช้งานได้ปกติผ่าน attach file)\n\nคุณต้องการดำเนินการต่อหรือไม่?",
          );
          if (!userConfirmed) {
            setIsUploading(false);
            return; // Stop the process if the user cancels
          }
        }
      } catch (error) {
        console.error("Error checking media duration:", error);
        const userConfirmed = window.confirm(
          "ไม่สามารถตรวจสอบความยาวของไฟล์ได้ คุณยังต้องการอัปโหลดต่อหรือไม่?",
        );
        if (!userConfirmed) {
          setIsUploading(false);
          return;
        }
      }
    }
    
    let calculatedMetadata = { duration: "-", fileSize: "-", audioUrl: null };
    try {
      const fileSizeMB = (file.size / (1024 * 1024)).toFixed(2) + " MB";
      const durationSeconds = duration || (await getMediaDuration(file));
      const formattedDuration = formatDuration(durationSeconds);

      calculatedMetadata.fileSize = fileSizeMB;
      calculatedMetadata.duration = formattedDuration;
    } catch (error) {
      console.warn("Could not read media metadata on client-side:", error);
      // Fallback for file size if duration fails
      calculatedMetadata.fileSize =
        (file.size / (1024 * 1024)).toFixed(2) + " MB";
    }
    const result = await api.uploadFFmpegChunksWithPreview(
      file,
      (progress, message) => {
        setUploadProgress(progress);
      },
      skipTranscription,
      duration,
    );

    if (result.success) {
      const jobId = Date.now();
      
      // Store upload history with session-only audio chunks (no localStorage)
      const newJob = {
        id: jobId,
        jobId: result.jobId,
        fileName: file.name,
        mimetype: file.type,
        status: "transcribing",
        createdAt: new Date().toISOString(),
        metadata: calculatedMetadata,
        dbId: result.dbId,
        audioChunks: result.audioChunks || [], // Store directly in memory for session only
      };
      const updatedHistory = [newJob, ...uploadHistory];
      setUploadHistory(updatedHistory);
      localStorage.setItem(UPLOAD_HISTORY_KEY, JSON.stringify(updatedHistory.map(job => ({
        ...job,
        audioChunks: undefined // Don't save audio chunks to localStorage
      }))));
    } else {
      alert(
        `Failed to start transcription: ${result.error || "Unknown error"}`
      );
    }
    setIsUploading(false);
  };

  const handleFileUpload = async (
    file,
    skipTranscription = false,
    duration = 0,
  ) => {
    setIsUploading(true);
    
    // Add duration validation logic from FileUpload.jsx
    if (!skipTranscription) {
      try {
        const mediaDuration = duration || (await getMediaDuration(file));
        const maxDuration = 150 * 60; // 150 minutes (2.5 hours)
        if (mediaDuration > maxDuration) {
          const userConfirmed = window.confirm(
            "การประชุม เกิน 2.5 ชม คุยสามารถทำรายการต่อไปได้ แต่ว่า คำพูดที่ถอดอาจไม่ครบถ้วน (แต่คุณยังใช้งานได้ปกติผ่าน attach file)\n\nคุณต้องการดำเนินการต่อหรือไม่?",
          );
          if (!userConfirmed) {
            setIsUploading(false);
            return; // Stop the process if the user cancels
          }
        }
      } catch (error) {
        console.error("Error checking media duration:", error);
        const userConfirmed = window.confirm(
          "ไม่สามารถตรวจสอบความยาวของไฟล์ได้ คุณยังต้องการอัปโหลดต่อหรือไม่?",
        );
        if (!userConfirmed) {
          setIsUploading(false);
          return;
        }
      }
    }
    
    let calculatedMetadata = { duration: "-", fileSize: "-", audioUrl: null };
    try {
      const fileSizeMB = (file.size / (1024 * 1024)).toFixed(2) + " MB";
      const durationSeconds = duration || (await getMediaDuration(file));
      const formattedDuration = formatDuration(durationSeconds);

      calculatedMetadata.fileSize = fileSizeMB;
      calculatedMetadata.duration = formattedDuration;
    } catch (error) {
      console.warn("Could not read media metadata on client-side:", error);
      // Fallback for file size if duration fails
      calculatedMetadata.fileSize =
        (file.size / (1024 * 1024)).toFixed(2) + " MB";
    }
    const result = await api.startTranscription(
      file,
      skipTranscription,
      duration,
    );

    if (result.success) {
      // --- MODIFICATION: Store the file object temporarily ---
      // This is a simple way to access it later in handleProceed.
      // A more advanced solution might use a global context or a Map.
      const newJob = {
        id: Date.now(),
        jobId: result.jobId,
        fileName: file.name,
        mimetype: file.type,
        status: "transcribing",
        createdAt: new Date().toISOString(),
        metadata: calculatedMetadata,
        dbId: result.dbId,
      };
      const updatedHistory = [newJob, ...uploadHistory];
      setUploadHistory(updatedHistory);
      localStorage.setItem(UPLOAD_HISTORY_KEY, JSON.stringify(updatedHistory));
    } else {
      alert(
        `Failed to start transcription: ${result.error || "Unknown error"}`
      );
    }
    setIsUploading(false);
  };

  // ในไฟล์ App.jsx

  const handleImport = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const json = JSON.parse(e.target.result);

        // 1. ตรวจสอบ Signature
        if (
          json.appSignature !== "YungYuenYor_Export_v1" ||
          !json.data ||
          !json.data.id
        ) {
          alert("ไฟล์ไม่ถูกต้องหรือไม่ใช่ไฟล์จาก 'ยั่งยืนย่อ'");
          return;
        }

        const newMeetingData = json.data;

        const fileTitle = newMeetingData.title || "Untitled Meeting";
        const detailsTitle = newMeetingData.meetingDetails?.title;
        let detailsTitleLine = "";
        if (
          detailsTitle &&
          detailsTitle.trim() !== "" &&
          detailsTitle !== fileTitle
        ) {
          detailsTitleLine = `\nหัวข้อ: "${detailsTitle}"`;
        }

        const existingMeetingIndex = savedMeetings.findIndex(
          (m) => m.id === newMeetingData.id
        );

        let updatedMeetings;
        let wasOverwrite = false;

        // 2. ตรวจสอบว่ามีข้อมูลซ้ำหรือไม่
        if (existingMeetingIndex > -1) {
          const overwriteConfirmationMessage = `พบข้อมูลการประชุมที่มีอยู่แล้ว:

ไฟล์: "${fileTitle}"${detailsTitleLine}

การเขียนทับจะอัปเดตเฉพาะข้อมูลหลัก (เช่น การถอดความ, ประวัติแชท) แต่จะ **ไม่ลบ** "การอ้างอิง" และ "ไฟล์แนบ" เดิมของคุณ

คุณต้องการเขียนทับข้อมูลหรือไม่?`;

          const userConfirmed = window.confirm(overwriteConfirmationMessage);

          if (userConfirmed) {
            // --- START: Logic การเขียนทับแบบปลอดภัย ---
            // 1. ดึงข้อมูลเดิมออกมา
            const oldMeetingData = savedMeetings[existingMeetingIndex];

            // 2. สร้างข้อมูลใหม่โดยรวมข้อมูลเดิมที่ต้องการเก็บไว้
            const mergedMeetingData = {
              ...newMeetingData, // นำข้อมูลใหม่ทั้งหมดเข้ามา
              referencedMeetingIds: oldMeetingData.referencedMeetingIds || [], // แต่ใช้ "การอ้างอิง" จากของเดิม
              attachments: oldMeetingData.attachments || [], // และใช้ "ไฟล์แนบ" จากของเดิม
            };

            // 3. อัปเดต Array ด้วยข้อมูลที่รวมแล้ว
            updatedMeetings = [...savedMeetings];
            updatedMeetings[existingMeetingIndex] = mergedMeetingData;
            wasOverwrite = true;
            // --- END: Logic การเขียนทับแบบปลอดภัย ---
          } else {
            return; // ผู้ใช้ยกเลิก
          }
        } else {
          // --- กรณีนำเข้าใหม่ (ยังคงล้างข้อมูลเหมือนเดิม) ---
          const importConfirmationMessage = `คุณกำลังจะนำเข้าข้อมูล:

ไฟล์: "${fileTitle}"${detailsTitleLine}

**คำเตือน:** ข้อมูล "การอ้างอิง" และ "ไฟล์แนบ" ที่มากับไฟล์นี้จะไม่ถูกนำเข้ามาด้วย

ต้องการดำเนินการต่อหรือไม่?`;

          const userConfirmed = window.confirm(importConfirmationMessage);
          if (!userConfirmed) return;

          // ทำความสะอาดข้อมูลก่อนเพิ่มเข้าไปใหม่
          newMeetingData.referencedMeetingIds = [];
          newMeetingData.attachments = [];
          updatedMeetings = [newMeetingData, ...savedMeetings];
        }

        // 3. อัปเดต State และ localStorage
        updatedMeetings.sort(
          (a, b) =>
            new Date(b.lastModified || b.createdAt) -
            new Date(a.lastModified || a.createdAt)
        );
        setSavedMeetings(updatedMeetings);
        localStorage.setItem(
          SAVED_MEETINGS_KEY,
          JSON.stringify(updatedMeetings)
        );

        // 4. สร้างข้อความแจ้งเตือน + ถามคำถาม
        const successMessage = wasOverwrite
          ? `เขียนทับข้อมูล "${fileTitle}" สำเร็จ!`
          : `นำเข้าข้อมูล "${fileTitle}" สำเร็จ!`;

        const openNowConfirmationMessage = `${successMessage}\n\nคุณต้องการเปิดการประชุมนี้เพื่อทำงานต่อเลยหรือไม่?`;
        const openNowConfirmation = window.confirm(openNowConfirmationMessage);

        // 5. ถ้าผู้ใช้ยืนยัน ให้เปิดการประชุมนั้นทันที
        if (openNowConfirmation) {
          handleLoadMeetingFromHistory(newMeetingData.id);
        }
      } catch (error) {
        alert("เกิดข้อผิดพลาดในการอ่านไฟล์ JSON: " + error.message);
      }
    };

    reader.onerror = () => {
      alert("เกิดข้อผิดพลาดในการอ่านไฟล์");
    };

    reader.readAsText(file);
    event.target.value = "";
  };
  // --- END: ฟังก์ชัน Import ---

  // Helper functions for managing split file history
  const getSplitFileHistory = () => {
    try {
      return JSON.parse(localStorage.getItem(SPLIT_FILE_HISTORY_KEY) || "{}");
    } catch (error) {
      console.error("Error reading split file history:", error);
      return {};
    }
  };

  const getAudioChunksForJob = (jobId) => {
    const splitHistory = getSplitFileHistory();
    return splitHistory[jobId] || [];
  };

  const cleanupSplitFileHistory = (jobId) => {
    const splitHistory = getSplitFileHistory();
    if (splitHistory[jobId]) {
      delete splitHistory[jobId];
      localStorage.setItem(SPLIT_FILE_HISTORY_KEY, JSON.stringify(splitHistory));
    }
  };

  // Helper functions for managing saved meeting audio chunks
  const getSavedOriginalRecorder = () => {
    try {
      return JSON.parse(localStorage.getItem(SAVED_ORIGINAL_RECORDER_KEY) || "{}");
    } catch (error) {
      console.error("Error reading saved original recorder:", error);
      return {};
    }
  };

  const getAudioChunksForSavedMeeting = (meetingId) => {
    const savedRecorder = getSavedOriginalRecorder();
    return savedRecorder[meetingId] || [];
  };

  const cleanupSavedOriginalRecorder = (meetingId) => {
    const savedRecorder = getSavedOriginalRecorder();
    if (savedRecorder[meetingId]) {
      delete savedRecorder[meetingId];
      localStorage.setItem(SAVED_ORIGINAL_RECORDER_KEY, JSON.stringify(savedRecorder));
    }
  };

  const handleDeleteUploadHistoryItem = (jobId) => {
    const jobToDelete = uploadHistory.find((j) => j.id === jobId);
    const userConfirmed = window.confirm(
      `Are you sure you want to delete "${jobToDelete?.fileName}"?`
    );
    if (userConfirmed) {
      // Clean up audio chunks from split file history
      cleanupSplitFileHistory(jobId);
      
      const updatedHistory = uploadHistory.filter((j) => j.id !== jobId);
      setUploadHistory(updatedHistory);
      localStorage.setItem(UPLOAD_HISTORY_KEY, JSON.stringify(updatedHistory));
    }
  };

  const handleRetranscribe = async (dbId) => {
    const result = await api.retranscribe(dbId);
    if (result.success) {
      const updatedHistory = uploadHistory.map((item) => {
        if (item.dbId === dbId) {
          return {
            ...item,
            status: "transcribing",
            // Reset relevant fields
            transcriptContent: null,
            error: null,
            retryCount: 0,
          };
        }
        return item;
      });
      setUploadHistory(updatedHistory);
      localStorage.setItem(UPLOAD_HISTORY_KEY, JSON.stringify(updatedHistory));
    } else {
      alert(`Failed to re-transcribe: ${result.error || "Unknown error"}`);
    }
  };

  const handleRetry = async (dbId) => {
    const result = await api.retryTranscription(dbId);
    if (result.success) {
      const updatedHistory = uploadHistory.map((item) => {
        if (item.dbId === dbId) {
          return {
            ...item,
            status: "transcribing",
            retryCount: (item.retryCount || 0) + 1,
          };
        }
        return item;
      });
      setUploadHistory(updatedHistory);
      localStorage.setItem(UPLOAD_HISTORY_KEY, JSON.stringify(updatedHistory));
    } else {
      alert(
        `Failed to retry transcription: ${result.error || "Unknown error"}`
      );
    }
  };
  const handleAIAssist = async () => {
    if (!activeMeeting || !activeMeeting.transcript?.content) {
      throw new Error("ไม่มีข้อมูลการถอดความสำหรับให้ AI วิเคราะห์");
    }

    try {
      const result = await api.aiAssist(activeMeeting.transcript.content);

      if (result.success) {
        updateActiveMeetingData({
          meetingDetails: {
            ...activeMeeting.meetingDetails,
            ...result.data,
          },
        });
      } else {
        throw new Error(result.error || "AI ไม่สามารถสร้างข้อมูลได้");
      }
    } catch (error) {
      console.error("AI Assist Error in App.jsx:", error);
      throw error;
    }
  };
  const handleProceed = (jobId, attachments) => {
    const jobToProceed = uploadHistory.find((j) => j.id === jobId);
    if (!jobToProceed || jobToProceed.status !== "finished") {
      alert("This job is not ready to proceed.");
      return;
    }

    let formattedAttachments = (attachments || []).map((att) => {
      // The main transcript file is now also an attachment.
      // We need to build its object correctly.
      const fileId = att.path; // This comes from jobToProceed.jobId
      return {
        id: `file_${fileId}`, // Consistent ID format
        fileId: fileId,
        fileName: att.name,
        mimetype: jobToProceed.mimetype || "application/octet-stream", // Use saved mimetype
        status: "active",
        expiryDate: addDays(new Date(), 2).toISOString(),
        useInChat: att.checked || false,
      };
    });
    //"transcriptContent":"file too large to automatic transcipt"
    if (
      jobToProceed.transcriptContent === "file too large to automatic transcipt"
    ) {
      formattedAttachments = [];
      const mainFileAttachment = {
        id: `file_${jobToProceed.jobId}`,
        fileId: jobToProceed.jobId,
        fileName: jobToProceed.fileName,
        mimetype: jobToProceed.mimetype || "application/octet-stream",
        status: "active",
        // This expiry date might not be accurate, but it's a reasonable default
        expiryDate: addDays(new Date(), 2).toISOString(),
        useInChat: true, // <-- Set to true by default
      };
      // Add it to the beginning of the attachments array
      
      formattedAttachments.push(mainFileAttachment);
    }

    // No longer move audio chunks to saved meetings (session-only audio)
    // Audio chunks are only available during the current upload session

    // The metadata is already stored in the job object, so no new calculation is needed.
    const newMeeting = {
      id: jobToProceed.id,
      jobId: jobToProceed.jobId,
      title: jobToProceed.fileName,
      createdAt: jobToProceed.createdAt,
      lastModified: new Date().toISOString(),
      transcript: {
        content:
          jobToProceed.transcriptContent || "Transcript content not found.",
        fileName: jobToProceed.fileName,
        metadata: jobToProceed.metadata || { duration: "-", fileSize: "-" }, // Use stored metadata
      },
      meetingDetails: {},
      chatHistory: [],
      summaries: [],
      referencedMeetingIds: [],
      attachments: formattedAttachments,
      // No audio chunk references for saved meetings
    };

    const updatedUploadHistory = uploadHistory.filter((j) => j.id !== jobId);
    const updatedSavedMeetings = [newMeeting, ...savedMeetings];

    setUploadHistory(updatedUploadHistory);
    localStorage.setItem(
      UPLOAD_HISTORY_KEY,
      JSON.stringify(updatedUploadHistory)
    );

    setSavedMeetings(updatedSavedMeetings);
    localStorage.setItem(
      SAVED_MEETINGS_KEY,
      JSON.stringify(updatedSavedMeetings)
    );

    setActiveMeeting(newMeeting);
  };

  const handleLoadMeetingFromHistory = (meetingId) => {
    if (activeMeeting && activeMeeting.id !== meetingId) {
      const userConfirmed = window.confirm(
        "You have an active session. Loading another will discard unsaved changes. Continue?"
      );
      if (!userConfirmed) return;
    }
    const meetingToLoad = savedMeetings.find((m) => m.id === meetingId);
    if (meetingToLoad) {
      setActiveMeeting(meetingToLoad);
    }
  };

  const handleDeleteSavedMeeting = (meetingId, title) => {
    const userConfirmed = window.confirm(
      `Are you sure you want to permanently delete this saved meeting?\n\n"${title}"`
    );
    if (userConfirmed) {
      if (activeMeeting?.id === meetingId) {
        setActiveMeeting(null);
      }
      const updatedMeetings = savedMeetings.filter((m) => m.id !== meetingId);
      setSavedMeetings(updatedMeetings);
      localStorage.setItem(SAVED_MEETINGS_KEY, JSON.stringify(updatedMeetings));
    }
  };

  const handleResetAndGoHome = () => {
    if (activeMeeting) {
      const userConfirmed = window.confirm(
        "Are you sure you want to discard unsaved changes and return to the home screen?"
      );
      if (userConfirmed) {
        setActiveMeeting(null);
      }
    } else {
      setActiveMeeting(null);
    }
  };

  const updateActiveMeetingData = (updatedData) => {
    if (!activeMeeting) return;
    setActiveMeeting((prev) => ({ ...prev, ...updatedData }));
  };

  // Centralized save function to ensure consistency
  const saveMeeting = (meetingToSave) => {
    if (!meetingToSave) return false;

    const updatedMeetingWithTimestamp = {
      ...meetingToSave,
      lastModified: new Date().toISOString(),
    };

    const updatedMeetingsList = savedMeetings.map((m) =>
      m.id === updatedMeetingWithTimestamp.id ? updatedMeetingWithTimestamp : m
    );

    setSavedMeetings(updatedMeetingsList);
    localStorage.setItem(
      SAVED_MEETINGS_KEY,
      JSON.stringify(updatedMeetingsList)
    );

    // Also update the active meeting in state to ensure UI consistency (e.g., for the timestamp)
    setActiveMeeting(updatedMeetingWithTimestamp);

    return true;
  };

  const handleSaveActiveMeeting = () => {
    return saveMeeting(activeMeeting);
  };

  // In App.jsx, replace your old handleSendMessage with this one.
  const handleUpdateReferences = (newReferencedIds) => {
    if (!activeMeeting) return;
    // ใช้ functional update เพื่อความปลอดภัย
    setActiveMeeting((prev) => ({
      ...prev,
      referencedMeetingIds: newReferencedIds || [],
    }));
  };

  const handleUpdateAttachments = (newAttachments) => {
    if (!activeMeeting) return;
    const updatedMeeting = {
      ...activeMeeting,
      attachments: newAttachments,
    };
    // Directly save the meeting with the updated attachments
    saveMeeting(updatedMeeting);
  };

  const handleSendMessage = async (messageText) => {
    // Guard clause: Do nothing if there's no active session.
    if (!activeMeeting) {
      console.error("handleSendMessage called without an active meeting.");
      return;
    }

    // 1. Create the user's message object.
    const userMessage = {
      id: Date.now(),
      type: "user",
      content: messageText,
      timestamp: new Date(),
    };

    // 2. Immediately update the UI with the user's message.
    // We create a new array with the user's message added.
    const updatedChatHistoryWithUserMsg = [
      ...activeMeeting.chatHistory,
      userMessage,
    ];
    updateActiveMeetingData({ chatHistory: updatedChatHistoryWithUserMsg });

    // Set the loading state for the chat UI
    setIsChatLoading(true);

    const referencedIds = activeMeeting.referencedMeetingIds || [];
    const attachments = activeMeeting.attachments || [];
    //const now = new Date();

    let finalTranscriptForAI;

    const now = new Date();
    // กรองไฟล์ที่ 'ใช้ในแชท' และ 'ยังไม่หมดอายุ'
    const activeAttachments = attachments.filter(
      (att) => att.useInChat && new Date(att.expiryDate) > now
    );
    const attachmentPayload = activeAttachments.map((att) => ({
      fileId: `https://generativelanguage.googleapis.com/v1beta/` + att.fileId,
      fileName: att.mimetype,
    }));

    if (referencedIds.length > 0) {
      // --- กรณีมีการอ้างอิง ---

      // 1. สร้างส่วนของ "การประชุมหลัก"
      const mainMeetingContent = `### การประชุมหลัก
หัวข้อ: ${activeMeeting.title}

${activeMeeting.transcript.content}`;

      // 2. สร้างส่วนของ "การประชุมอ้างอิง"
      let referenceContent = "";
      referencedIds.forEach((refId, index) => {
        const refMeeting = savedMeetings.find((m) => m.id === refId);
        if (refMeeting) {
          // เพิ่มลำดับเข้าไปในหัวข้อเพื่อให้ AI รู้ว่าอันไหนมาก่อน
          referenceContent += `#### อ้างอิงที่ ${index + 1}: ${refMeeting.title}
${refMeeting.transcript.content}
\n`; // ใช้ \n ตัวเดียวเพื่อไม่ให้ห่างเกินไป
        }
      });

      // 3. ประกอบร่างทั้งหมด พร้อมคำนำสำหรับ AI
      finalTranscriptForAI = `คุณคือผู้ช่วยวิเคราะห์การประชุม ข้อมูลต่อไปนี้ประกอบด้วย "การประชุมหลัก" และ "การประชุมอ้างอิง" หลายรายการที่เรียงตามลำดับความสำคัญ โปรดใช้ข้อมูลทั้งหมดในการตอบคำถาม

---
${mainMeetingContent}
---

### การประชุมอ้างอิง (เรียงตามลำดับความสำคัญ)
${referenceContent}
---
`;
    } else {
      // --- กรณีไม่มีการอ้างอิง ---
      // ส่งไปตามปกติ ไม่ต้องมีคำอธิบายซับซ้อน
      finalTranscriptForAI = activeMeeting.transcript.content;
    }
    console.log("Final transcript for AI:", finalTranscriptForAI);

    // 3. Prepare the payload for the API.
    // IMPORTANT: Use the history *before* adding the user's new message for context.
    const payload = {
      meetingDetails: activeMeeting.meetingDetails,
      // transcript: activeMeeting.transcript.content, // <--- ใช้ตัวแปรรวมแทน
      transcript: finalTranscriptForAI, // <--- ใช้ตัวแปรรวม
      history: activeMeeting.chatHistory, // The history before the new message
      newMessage: messageText,
      attachments: attachmentPayload,
    };
    console.log(
      "Sending message to chat stream with payload:",
      JSON.stringify(payload, null, 2)
    );

    const botMessageId = Date.now() + 1;

    // 5. เพิ่ม Placeholder ของ Bot ลงใน UI
    const botPlaceholder = {
      id: botMessageId,
      type: "bot",
      content: "รอยั่งยืนหน่อยน้า...", // ใช้ตัวอักษรนี้เพื่อทำ animation typing cursor
      timestamp: new Date(),
    };
    setActiveMeeting((prev) => ({
      ...prev,
      chatHistory: [...updatedChatHistoryWithUserMsg, botPlaceholder],
    }));

    try {
      // 6. เรียก API และเริ่มอ่าน Stream
      const response = await api.getChatStream(payload);

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(
          `HTTP error! Status: ${response.status}, Body: ${errorText}`
        );
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let buffer = "";
      let currentBotMessageContent = "";
      while (true) {
        // reader.read() จะให้ value เป็น Uint8Array (ข้อมูลดิบ)
        const { done, value } = await reader.read();
        if (done) {
          break; // สิ้นสุด Stream
        }
        buffer += decoder.decode(value, { stream: true });
        let boundary;
        while ((boundary = buffer.indexOf("\n\n")) >= 0) {
          const messageChunk = buffer.slice(0, boundary);
          buffer = buffer.slice(boundary + 2);

          const lines = messageChunk.split("\n");
          for (const line of lines) {
            if (line.startsWith("data:")) {
              const dataString = line.slice(5).trim();
              if (dataString) {
                try {
                  // **จุดสำคัญ:** Backend ส่งข้อมูลมาเป็น JSON string (เช่น "สวัสดี")
                  // เราต้อง parse เพื่อให้ได้ค่า string ที่แท้จริง (สวัสดี)
                  const text = JSON.parse(dataString);
                  currentBotMessageContent += text;
                } catch (e) {
                  console.error(
                    "Failed to parse SSE data chunk: ",
                    dataString,
                    e
                  );
                }
              }
            }
          }

          // อัปเดต UI ด้วยข้อความที่ได้รับมาล่าสุด
          setActiveMeeting((prev) => {
            if (!prev) return prev;
            const newHistory = prev.chatHistory.map((msg) =>
              msg.id === botMessageId
                ? { ...msg, content: currentBotMessageContent + "▋" }
                : msg
            );
            return { ...prev, chatHistory: newHistory };
          });
        }
      }

      // --- START: Final Buffer Processing ---
      // After the loop, process any remaining data in the buffer
      // This handles cases where the last message chunk isn't followed by \n\n
      if (buffer.length > 0) {
        const lines = buffer.split("\n");
        for (const line of lines) {
          if (line.startsWith("data:")) {
            const dataString = line.slice(5).trim();
            if (dataString) {
              try {
                const text = JSON.parse(dataString);
                currentBotMessageContent += text;
              } catch (e) {
                console.error(
                  "Failed to parse final SSE data chunk: ",
                  dataString,
                  e
                );
              }
            }
          }
        }
        // Final UI update with the complete message
        setActiveMeeting((prev) => {
          if (!prev) return prev;
          const newHistory = prev.chatHistory.map((msg) =>
            msg.id === botMessageId
              ? { ...msg, content: currentBotMessageContent + "▋" } // Keep cursor for now
              : msg
          );
          return { ...prev, chatHistory: newHistory };
        });
      }
      // --- END: Final Buffer Processing ---
    } catch (error) {
      console.error("Chat stream error caught in App.jsx:", {
        message: error.message,
        stack: error.stack,
        errorObj: error,
      });
      // 9. แสดงข้อผิดพลาดใน UI โดยการอัปเดตข้อความของบอท
      setActiveMeeting((prev) => {
        if (!prev) return prev;
        const newHistory = prev.chatHistory.map((msg) =>
          msg.id === botMessageId
            ? {
                ...msg,
                content: `ขออภัย, เกิดข้อผิดพลาด: ${error.message}`,
                isError: true, // เพิ่ม flag เพื่อใส่ style สีแดงได้
              }
            : msg
        );
        return { ...prev, chatHistory: newHistory };
      });
    } finally {
      // 10. หยุดสถานะ Loading และลบ typing cursor ออก
      setIsChatLoading(false);
      setActiveMeeting((prev) => {
        if (!prev) return prev;
        const newHistory = prev.chatHistory.map((msg) => {
          if (msg.id === botMessageId) {
            // ลบ cursor '▋' ออกเมื่อ stream จบ
            return { ...msg, content: msg.content.replace(/▋$/, "") };
          }
          return msg;
        });
        return { ...prev, chatHistory: newHistory };
      });
    }
  };
  const handleSendEmail = async (emailPayload) => {
    console.log("App.js: Received request to send email:", emailPayload);
    try {
      // เรียกใช้ฟังก์ชันจาก ApiService
      const result = await api.sendEmail(emailPayload);

      if (result.success) {
        console.log("Email sent successfully via API:", result.data);
        // คุณอาจจะแสดง notification "ส่งอีเมลสำเร็จแล้ว" ที่นี่
        return true; // ส่งสัญญาณว่าสำเร็จ
      } else {
        // ถ้า API คืนค่า error, ให้โยน error ออกไป
        console.error("Failed to send email via API:", result.error);
        throw new Error(result.error);
      }
    } catch (error) {
      console.error("Caught error in handleSendEmail:", error);
      // โยน error อีกครั้งเพื่อให้ Modal จัดการได้
      throw error;
    }
  };
  // --- RENDER LOGIC ---

  /* if (!isAuthenticated) {
    return (
      <div className="flex flex-col h-screen bg-gray-50">
        <Header isLocked={true} onReset={handleResetAndGoHome} />
        <main className="flex-1 flex items-center justify-center p-4">
          <PinLockScreen
            onPinSubmit={handlePinSubmit}
            error={pinError}
            isLoading={isVerifyingPin}
          />
        </main>
      </div>
    );
  } */
  if (!isAuthenticated) {
    return (
      // --- เพิ่มพื้นหลัง Gradient ที่สวยงาม ---
      <div className="flex flex-col h-screen bg-gradient-to-br from-green-50 via-slate-50 to-white">
        <Header isLocked={true} onReset={handleResetAndGoHome} />
        <main className="flex-1 flex items-center justify-center p-4">
          <LoginScreen
            onLoginSubmit={handleLoginSubmit}
            error={authError}
            isLoading={isLoggingIn}
            isVideoError={isVideoError}
            setIsVideoError={setIsVideoError}
          />
        </main>
      </div>
    );
  }
  if (activeMeeting) {
    return (
      <div className="flex flex-col h-screen overflow-hidden bg-gray-50">
        <Header
          // *** FIX ***: The component name is `Header`, the prop name is `history`.
          history={savedMeetings}
          onSelectHistory={handleLoadMeetingFromHistory}
          onDelete={handleDeleteSavedMeeting}
          isLocked={!isAuthenticated}
          onReset={handleResetAndGoHome}
          onLogout={handleLogout}
          getAudioChunksForSavedMeeting={getAudioChunksForSavedMeeting}
        />
        <main className="flex-1 min-h-0 container mx-auto p-4 grid grid-cols-1 gap-4">
          <PanelGroup direction={layoutDirection}>
            <Panel defaultSize={41} minSize={20}>
              <TranscriptPanel
                jobId={activeMeeting.jobId} // Correct
                transcript={activeMeeting.transcript?.content || ""} // Correct
                fileName={activeMeeting.fileName || activeMeeting.title} // Correct
                metadata={activeMeeting.transcript?.metadata || null} // Correct
                summaries={activeMeeting.summaries || []}
                meetingDetails={activeMeeting.meetingDetails || {}}
                onReset={handleResetAndGoHome}
                onSave={handleSaveActiveMeeting}
                onUpdateDetails={(details) =>
                  updateActiveMeetingData({ meetingDetails: details })
                }
                onDeleteSummary={(summaryId) =>
                  updateActiveMeetingData({
                    summaries: (activeMeeting.summaries || []).filter(
                      (s) => s.id !== summaryId
                    ),
                  })
                }
                onUpdateSummaries={(newSummaries) =>
                  updateActiveMeetingData({ summaries: newSummaries })
                }
                allMeetings={savedMeetings}
                activeMeetingId={activeMeeting.id}
                referencedMeetingIds={activeMeeting.referencedMeetingIds || []}
                onUpdateReferences={handleUpdateReferences}
                onAIAssist={handleAIAssist}
                onSendEmail={handleSendEmail}
                attachments={activeMeeting.attachments || []}
                onUpdateAttachments={handleUpdateAttachments}
              />
            </Panel>
            <PanelResizeHandle
              className={`flex items-center justify-center group ${
                layoutDirection === "vertical"
                  ? "h-3 w-full cursor-row-resize" // สไตล์สำหรับโหมดแนวตั้ง (ตัวจับเป็นแนวนอน)
                  : "w-3 h-full cursor-col-resize" // สไตล์สำหรับโหมดแนวนอน (ตัวจับเป็นแนวตั้ง)
              }`}
            >
              <div
                className={`rounded-full bg-gray-300 transition-colors group-hover:bg-green-700 ${
                  layoutDirection === "vertical"
                    ? "h-1 w-14" // เส้นแนวนอนที่มองเห็น
                    : "w-1 h-14" // เส้นแนวตั้งที่มองเห็น
                }`}
              />
            </PanelResizeHandle>
            <Panel defaultSize={59} minSize={20}>
              <ChatPanel
                user={user}
                transcript={activeMeeting.transcript?.content || ""}
                messages={activeMeeting.chatHistory || []}
                onSendMessage={handleSendMessage}
                isLoading={isChatLoading}
                attachments={activeMeeting.attachments || []}
                onSaveSummary={(summaryContent) => {
                  const newSummary = {
                    id: Date.now(),
                    content: summaryContent,
                    createdAt: new Date().toISOString(),
                    title: activeMeeting.title || "Summary",
                  };
                  updateActiveMeetingData({
                    summaries: [...(activeMeeting.summaries || []), newSummary],
                  });
                }}
                onUpdateMessages={(newMessages) =>
                  updateActiveMeetingData({ chatHistory: newMessages })
                }
              />
            </Panel>
          </PanelGroup>
        </main>
      </div>
    );
  }

  if (isUploading) {
    return (
      <div className="flex flex-col h-screen bg-gray-50">
        <Header
          // *** FIX ***: Also pass props here so the history menu works even while loading.
          history={savedMeetings}
          onSelectHistory={handleLoadMeetingFromHistory}
          onDelete={handleDeleteSavedMeeting}
          isLocked={!isAuthenticated}
          onReset={handleResetAndGoHome}
          onLogout={handleLogout}
        />
        <main className="flex-1 flex items-center justify-center p-4">
          <LoadingSpinner
            quoteData={quoteData}
            uploadProgress={uploadProgress}
          />
        </main>
      </div>
    );
  }

  // Default "home" screen
  return (
    <div className="flex flex-col h-screen overflow-hidden bg-gray-50">
      <Header
        // *** FIX ***: The main history menu should show the `savedMeetings` list.
        history={savedMeetings}
        onSelectHistory={handleLoadMeetingFromHistory}
        onDelete={handleDeleteSavedMeeting}
        isLocked={!isAuthenticated}
        onReset={handleResetAndGoHome}
        onLogout={handleLogout}
      />
      <main className="flex-1 overflow-y-auto p-2 md:p-8">
        <div className="max-w-3xl mx-auto">
          <motion.div
            className="text-center mb-1"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            {isVideoError ? (
              // --- 1. เพิ่มขอบเขียวที่ Fallback Image ---
              <img
                src="/images/yy_processing.jpg"
                alt="ยั่งยืนย่อ Logo"
                className="w-32 h-32 mx-auto mb-6 rounded-2xl ring-2 ring-green-700 ring-offset-1 ring-offset-slate-50"
              />
            ) : (
              // --- 2. เพิ่มขอบเขียวที่ Video หลัก ---
              <video
                autoPlay
                loop
                muted
                playsInline
                title="ยั่งยืนย่อ Logo Animation"
                className="w-32 h-32 mx-auto mb-6 rounded-2xl object-cover scale-110 ring-2 ring-green-700 ring-offset-1 ring-offset-slate-50"
                onError={() => setIsVideoError(true)}
              >
                <source src="/vdo/yy_landing_vdo.MP4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            )}

            <h1 className="text-3xl font-bold text-green-700 tracking-wide ">
              ยั่งยืน'ย่อ'
            </h1>

            <p className="text-gray-600 mt-2">
              อัปโหลดไฟล์เพื่อเริ่ม "ย่อ"
              หรือทำงานต่อจากประวัติการประชุมที่บันทึกไว้
            </p>
          </motion.div>
          <div className="bg-white p-6 rounded-lg shadow-md border border-gray-200 mb-2">
            <FileUpload
              onFileUpload={handleFileUploadLogic}
              isLoading={isUploading}
            />
          </div>
          <div className="mb-8">
            <label
              htmlFor="import-file-input"
              className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-white border-2 border-dashed border-slate-300 rounded-lg text-slate-500 font-semibold cursor-pointer transition-all hover:border-green-500 hover:text-green-600 hover:bg-green-50"
            >
              <FiImport className="w-5 h-5" />
              <span>นำเข้าข้อมูล (.yyy.json)</span>
            </label>
            <input
              id="import-file-input"
              type="file"
              accept=".yyy.json,application/json"
              onChange={handleImport}
              className="sr-only"
            />
          </div>
          {/*  {savedMeetings.length > 0 && (
            <div className="hidden sm:flex items-center justify-center gap-2 mt-2 mb-2">
              <FiInfo className="w-4 h-4 text-gray-500" />
              <p className="text-xs text-gray-500">
                กำลังหาประวัติการประชุมอยู่ใช่ไหม? ลองดูที่เมนูทางขวาบน
              </p>
            </div>
          )} */}

          <div
            onClick={() => setIsMobileHistoryModalOpen(true)}
            className="sm:hidden mb-8 p-4 bg-white rounded-xl shadow-sm border border-gray-200 flex justify-between items-center cursor-pointer group hover:bg-gray-50 active:scale-[0.98] transition-all"
          >
            <div>
              <h2 className="text-lg font-semibold text-gray-800 group-hover:text-green-700">
                การประชุมที่บันทึกไว้
              </h2>
              <p className="text-sm text-gray-500">
                {savedMeetings.length > 0
                  ? `คุณมี ${savedMeetings.length} รายการ`
                  : "ยังไม่มีรายการที่บันทึก"}
              </p>
            </div>
            <FiChevronRight className="w-6 h-6 text-gray-400 group-hover:text-green-700 transition-colors" />
          </div>
          <div className="flex items-center justify-between gap-3 border-b border-slate-200 pb-3 mt-4 mb-4">
            <div>
              <h2 className="text-xl font-semibold text-green-800">
                ประวัติการอัปโหลด{" "}
                {uploadHistory.length > 0 ? `(${uploadHistory.length})` : ""}
              </h2>
              <p className="text-sm text-slate-500 -mt-0.5">
                เมื่อถอดความสำเร็จ กด 'ย่อ' เพื่อให้ยั่งยืนทำงานต่อ (ไฟล์เกิน 60
                นาทีอาจใช้เวลานานกว่า 15 นาที)
              </p>
            </div>
          </div>
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1, duration: 0.3 }}
            className="bg-slate-100/70 border border-slate-200/80 rounded-xl p-3 mb-6"
          >
            <div className="flex flex-wrap justify-center items-center gap-3">
              {/* 1. ป้ายสถานะ: สำเร็จ */}
              {/* --- ขยาย Padding (py-2) และเพิ่มระยะห่าง (gap-3) --- */}
              <div className="group flex items-center gap-3 bg-white border border-slate-200 rounded-lg px-4 py-2 shadow-sm cursor-pointer transition-all hover:shadow-md">
                <img
                  src="/images/yy_success_zoom.jpg"
                  alt="สถานะสำเร็จ"
                  className="w-[60px] h-[60px] rounded-full object-cover transition-transform duration-200 ease-in-out  group-hover:scale-150 ring-2 ring-green-700 ring-offset-1 ring-offset-white"
                />
                <p className="text-sm text-slate-700">
                  <span className="font-semibold">สำเร็จ</span>
                </p>
              </div>

              {/* 2. ป้ายสถานะ: กำลังทำงาน */}
              <div className="group flex items-center gap-3 bg-white border border-slate-200 rounded-lg px-4 py-2 shadow-sm cursor-pointer transition-all hover:shadow-md">
                <img
                  src="/images/yy_processing_zoom.jpg"
                  alt="สถานะกำลังทำงาน"
                  className="w-[60px] h-[60px] rounded-full object-cover transition-transform duration-200 ease-in-out group-hover:scale-150 ring-2 ring-yellow-400 ring-offset-1 ring-offset-white"
                />
                <p className="text-sm text-slate-700">
                  <span className="font-semibold">กำลังทำงาน</span>
                </p>
              </div>

              {/* 3. ป้ายสถานะ: ล้มเหลว */}
              <div className="group flex items-center gap-3 bg-white border border-slate-200 rounded-lg px-4 py-2 shadow-sm cursor-pointer transition-all hover:shadow-md">
                <img
                  src="/images/yy_failed_zoom.jpg"
                  alt="สถานะล้มเหลว"
                  className="w-[60px] h-[60px] rounded-full object-cover transition-transform duration-200 ease-in-out group-hover:scale-150 ring-2 ring-red-400 ring-offset-1 ring-offset-white"
                />
                <p className="text-sm text-slate-700">
                  <span className="font-semibold">ล้มเหลว</span>
                </p>
              </div>
            </div>
          </motion.div>
          <MeetingHistoryList
            meetings={uploadHistory}
            onProceed={handleProceed}
            onDelete={handleDeleteUploadHistoryItem}
            onRetry={handleRetry}
            onRetranscribe={handleRetranscribe}
            getAudioChunksForJob={getAudioChunksForJob}
          />
          {/* <div className="flex items-center justify-center gap-2 mt-2 mb-2">
            <FiInfo className="w-4 h-4 text-gray-500" />
            <p className="text-xs text-gray-500">
              หากใช้เวลาประมวลผลเกิน 15 นาที statusจะถูกปรับเป็น Failed
            </p>
          </div> */}
        </div>
      </main>
      <MobileHistoryModal
        isOpen={isMobileHistoryModalOpen}
        onClose={() => setIsMobileHistoryModalOpen(false)}
        meetings={savedMeetings}
        onLoad={handleLoadMeetingFromHistory}
        onDelete={handleDeleteSavedMeeting}
      />
    </div>
  );
}

export default App;
